import { render, staticRenderFns } from "./EventLiveEventerMessageList.vue?vue&type=template&id=fbf03a18&scoped=true&"
import script from "./EventLiveEventerMessageList.vue?vue&type=script&lang=js&"
export * from "./EventLiveEventerMessageList.vue?vue&type=script&lang=js&"
import style0 from "./EventLiveEventerMessageList.vue?vue&type=style&index=0&id=fbf03a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf03a18",
  null
  
)

export default component.exports